import { SVGProps } from 'react';

export const IconMapLocation = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='currentColor'
        d='M10 16.5C10 16.5 15.5 12.0376 15.5 9C15.5 5.96243 13.0376 3.5 10 3.5C6.96243 3.5 4.5 5.96243 4.5 9C4.5 12.0376 10 16.5 10 16.5ZM10 10.5C10.8284 10.5 11.5 9.82843 11.5 9C11.5 8.17157 10.8284 7.5 10 7.5C9.17157 7.5 8.5 8.17157 8.5 9C8.5 9.82843 9.17157 10.5 10 10.5Z'
      />
    </svg>
  );
};
